import { AmbulanceType } from '../../../../services/api';

export type RouteStop = {
  lat: number;
  lng: number;
  type: 'patient' | 'hospital';
  label: string;
};

// Helper to format ambulance type for display using API-loaded ambulance types
export const formatAmbulanceType = (type?: string, ambulanceTypes?: AmbulanceType[]): string => {
  if (!type) return 'Unknown Type';
  if (ambulanceTypes && ambulanceTypes.length > 0) {
    const found = ambulanceTypes.find((t) => t.metadata?.name === type);
    if (found) {
      // Prefer displayName from API if present (using a safe cast)
      const anyType = found as any;
      const displayName = anyType?.metadata?.displayName as string | undefined;
      return displayName || found.metadata.name || type;
    }
  }
  // Fallback: replace hyphens/underscores and title-case first letter
  return type
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

// Helper to format ambulance duty status for display
export const formatAmbulanceStatus = (status?: string): string => {
  if (!status) return 'Unknown';
  const map: Record<string, string> = {
    available: 'Available',
    on_duty: 'On Duty',
    off_duty: 'Off Duty',
    maintenance: 'Maintenance',
  };
  const lower = status.toLowerCase();
  if (map[lower]) return map[lower];
  return status
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

